/** Feishu translations (PRIVATE fork) — registered via registerLocaleMessages (S5-i18n). */

export const feishuEn = {
  title: 'Feishu (Lark)',
  description:
    'Connect your Feishu account so the AI can search and read your Feishu knowledge base and cloud docs (only content you personally have permission to see).',
  notConfigured: 'The Feishu app is not configured yet. Set {appId} and {appSecret} in the server {env}.',
  account: 'Feishu Account',
  connectedAs: 'Connected',
  tokenValidUntil: 'Token valid until {date} (auto-refreshes on expiry)',
  tokenExpired: 'Token expired — please reconnect',
  notConnected: 'Not connected',
  reauthorize: 'Re-authorize',
  disconnect: 'Disconnect',
  connect: 'Connect Feishu',
  footnote:
    'Once connected, you can ask the AI to use the "Feishu Docs" tool to search/read your Feishu content. The search scope is strictly equal to what you can see in the Feishu client — it never touches docs you lack permission for. Content is never stored in the system; it is read live.',
  connected: 'Feishu connected',
  disconnected: 'Feishu disconnected',
  connectFailed: 'Connection failed',
  disconnectFailed: 'Disconnect failed',
  cannotStart: 'Unable to start Feishu authorization',
  loadFailed: 'Failed to load Feishu status',
};

export const feishuZh = {
  title: '飞书 (Feishu)',
  description: '连接你的飞书账号，让 AI 搜索并读取你的飞书知识库和云文档（仅限你本人有权限看到的内容）。',
  notConfigured: '飞书应用尚未配置。请在服务端 {env} 中设置 {appId} 和 {appSecret}。',
  account: '飞书账号',
  connectedAs: '已连接',
  tokenValidUntil: '令牌有效期至 {date}（过期自动刷新）',
  tokenExpired: '令牌已过期 — 请重新连接',
  notConnected: '未连接',
  reauthorize: '重新授权',
  disconnect: '断开',
  connect: '连接飞书',
  footnote:
    '连接后，在对话中可让 AI 使用「Feishu Docs」工具搜索/读取你的飞书内容。搜索范围严格等于你在飞书客户端能看到的范围，不会涉及你无权限的文档。内容不会被存入系统，均为实时读取。',
  connected: '飞书已连接',
  disconnected: '已断开飞书连接',
  connectFailed: '连接失败',
  disconnectFailed: '断开失败',
  cannotStart: '无法发起飞书授权',
  loadFailed: '加载飞书状态失败',
};
